// Типизированный доступ к переменным окружения Vite.
// Прямое обращение к `import.meta.env` за пределами этого файла — запрещено.

const FALLBACK_API_BASE_URL = 'http://localhost:3000'

/** Базовый URL бэкенда */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL ?? FALLBACK_API_BASE_URL

/** true → все запросы идут в реестр моков вместо сети */
export const USE_MOCKS: boolean = import.meta.env.VITE_API_MOCKS === 'true'

/** true — режим разработки (Vite dev-сервер) */
/** Username бота — из него собираются диплинки share-карточек и приглашений. */
export const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME ?? 'lunya_ryadom_bot'

export const IS_DEV: boolean = import.meta.env.DEV === true

/** Тестовый пользователь для разработки вне Telegram (браузер) */
export const DEV_USER_ID: string = import.meta.env.VITE_DEV_USER_ID ?? '1'
export const DEV_USER_NAME: string = import.meta.env.VITE_DEV_USER_NAME ?? 'Гость'

/** То же самое единым объектом — удобно для `env.DEV_USER_ID` в местах с несколькими полями */
export const env = {
  BOT_USERNAME,
  API_BASE_URL,
  USE_MOCKS,
  IS_DEV,
  DEV_USER_ID,
  DEV_USER_NAME,
} as const
